import { useQuery } from '@tanstack/react-query';
import { IKeepInTouchJobConfiguration } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'keepInTouchJobConfiguration/id';

export function useKeepInTouchConfiguration({ id }: { id: string }) {
	const userSession = useUserSession();
	return useQuery({
		enabled: !!id,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IKeepInTouchJobConfiguration>(
				`KeepInTouchJobConfiguration/${id}`,
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, id],
		meta: {
			toastErrorMessage: 'Failed to load configuration',
		},
	});
}

export const invalidateKeepInTouchConfiguration = (id: string) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, id] });
};
